import axios from 'axios'

// Get the base URL and merchant ID from environment variables
const baseURL = process.env.REACT_APP_CLOVER_BASE_URL
const merchantId = localStorage.getItem('merchant_id')

// Create an Axios instance
const cloverAPI = axios.create({
	baseURL: `${baseURL}${merchantId}`,
	headers: {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${localStorage.getItem('access_token')}`,
	},
})

export default cloverAPI
